module.exports = __webpack_public_path__ + "static/media/main-img1-final.5b8dd3ab.png";